import { Button, Checkbox, Divider, Space, TimePicker } from "antd";
import cn from "classnames";
import { useIntl } from "react-intl";
import styles from "./PlanTime.module.scss";
import { PlanTimePropsI } from "./PlanTime.props";
import { usePlanTimeControl } from "./usePlanTimeControl";
import Icon from "../Icon/Icon";
import dayjs from "dayjs";
import clock from "@assets/redesign/icons/clock.svg"
import ErrorsList from "@components/global/ErrorsList/ErrorsList";

export default function PlanTime(props: PlanTimePropsI) {

  const { formatMessage } = useIntl();
  const control = usePlanTimeControl(props);

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.disabled]: props.disabled,
      })}
    >
      <div className={styles.planTime__content}>
        <div className={styles.from}>
          <label>{formatMessage({ id: "plan_time.from" })}</label>
          <TimePicker // import from antd with Dayjs!
            suffixIcon={<Icon className={styles.clock} src={clock} noHover />}
            placeholder="..."
            use12Hours={props.hh_12}
            format={props.hh_12 ? "h:mm A" : "HH:mm"}
            className={cn(styles.picker, {
              [styles.disabled]: props.disabled,
            })}
            open={control.openStart}
            onOpenChange={control.setOpenStart}
            showNow={false}
            needConfirm={false}
            value={control.time[0]}
            onChange={(value, date) => {
              control.onChangeTime(value, 0);
            }}
            disabledTime={(current) => {
              return control.getFromFieldTimePickerDisabledTimes(
                control.time[1]?.hour() ?? 0,
                control.time[1]?.minute() ?? 0
              );
            }}
            getPopupContainer={(triggerNode: any) => {
              return document.getElementById("test-element") as HTMLElement;
            }}
            status={props.error ? "error" : undefined}
            renderExtraFooter={() => (
              <Space size="small" direction="vertical">
                <Checkbox
                  style={{ paddingTop: 12, paddingLeft: 12, paddingRight: 12 }}
                  checked={control.time[0] === null}
                  onClick={() => {
                    control.onChangeTime(null, 0);
                  }}
                >
                  {formatMessage({ id: "manage.plan_info.skip" })}
                </Checkbox>
                <Space size="small">
                  <Button type="text" onClick={() => { control.onChangeTime(dayjs(), 0); }}>
                    {formatMessage({ id: "manage.plan_info.now" })}
                  </Button>
                  <Button size="small" type="primary" onClick={() => control.setOpenStart(false)}>
                    OK
                  </Button>
                </Space>
              </Space>
            )}
          />
        </div>
        <div className={styles.until}>
          <label>{formatMessage({ id: "plan_time.until" })}</label>
          <TimePicker
            suffixIcon={<Icon className={styles.clock} src={clock} noHover />}
            placeholder="..."
            use12Hours={props.hh_12}
            format={props.hh_12 ? "h:mm A" : "HH:mm"}
            className={cn(styles.picker, {
              [styles.disabled]: props.disabled,
            })}
            open={control.openEnd}
            onOpenChange={control.setOpenEnd}
            showNow={false}
            needConfirm={false}
            value={control.time[1]}
            onChange={(value, date) => {
              control.onChangeTime(value, 1);
            }}
            disabledTime={(current) => {
              return control.getToFieldTimePickerDisabledTimes(
                control.time[0]?.hour() ?? 0,
                control.time[0]?.minute() ?? 0
              );
            }}
            getPopupContainer={(triggerNode: any) => {
              return document.getElementById("test-element") as HTMLElement;
            }}
            status={props.error ? "error" : undefined}
            renderExtraFooter={() => (
              <Space size="small" direction="vertical">
                <Checkbox
                  style={{ paddingTop: 12, paddingLeft: 12, paddingRight: 12 }}
                  checked={control.time[1] === null}
                  onClick={() => {
                    control.onChangeTime(null, 1);
                  }}
                >Пропустить</Checkbox>
                <Space size="small">
                  <Button type="text" onClick={() => { control.onChangeTime(dayjs(), 1); }}>Сейчас</Button>
                  <Button size="small" type="primary" onClick={() => control.setOpenEnd(false)}>
                    OK
                  </Button>
                </Space>
              </Space>
            )}
          />
        </div>
        {props.crossed && <div className={styles.crossed} />}
        {/* TODO: разобраться */}
        <input
          className={styles.value_input}
          id={`from_${props.id}`}
          tabIndex={-1}
          disabled
          value={control.time[0]?.format("HH:mm") ?? "00"}
        />
        <input
          className={styles.value_input}
          id={`until_${props.id}`}
          tabIndex={-1}
          disabled
          value={control.time[1]?.format("HH:mm") ?? "00"}
        />
      </div>
      <ErrorsList id={control.errors} />
    </div>
  );
}
